import {FC, useState} from "react";
import {LoadingSpinner} from "../../../ui/Loader";

interface IUserInfoCardProps {
  imageSrc: string;
  department: string | null;
  fullName: string;
  role: string | null;
  onClick?: () => void;
}

export const UserInfoCard: FC<IUserInfoCardProps> = ({
  imageSrc,
  department,
  fullName,
  role,
  onClick,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const handleImageLoad = () => {
    setIsLoading(false);
    setHasError(false);
  };

  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const target = e.target as HTMLImageElement;
    if (!hasError) {
      target.src = "/mocks/no-name.png";
      setHasError(true);
      setIsLoading(false);
    }
  };
  return (
    <div
      style={{
        color: "white",
        width: "100%",
        border: "1px solid rgba(255, 255, 255, 0.2)",
        borderRadius: "12px",
        padding: "3px 16px",
        backgroundColor: "#22272B",
        display: "flex",
        justifyContent: "start",
        gap: 12,
        alignItems: "center",
        cursor: onClick ? "pointer" : "default",
      }}
      onClick={onClick}
    >
      <div
        style={{
          position: "relative",
          width: 50,
          height: 50,
          borderRadius: "30%",
          overflow: "hidden",
        }}
      >
        {isLoading && <LoadingSpinner size={50} borderRadius="30%" />}

        <img
          src={imageSrc}
          width={50}
          height={50}
          alt="Icon"
          style={{
            borderRadius: "30%",
            display: "block",
            opacity: isLoading ? 0 : 1,
            transition: "opacity 0.3s ease",
          }}
          onLoad={handleImageLoad}
          onError={handleImageError}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
        }}
      >
        <span style={{color: "rgba(255, 255, 255, 0.6)", fontSize: 12}}>
          {department || ""}
        </span>
        <div style={{color: "#FAFAFA", fontSize: 16}}>{fullName}</div>
        <span style={{color: "rgba(255, 255, 255, 0.6)", fontSize: 12}}>
          {role || ""}
        </span>
      </div>
    </div>
  );
};
